import React, { useEffect } from 'react';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import AppRoutes from './Routing/AppRoutes';
import GlobalStyle from '../styles/GlobalStyle';
import {
  getApolloClient,
  ORGANISATION_SERVICE_ENDPOINT,
} from '../apollo/getApolloClient';
import isInCCLiframe from '../utils/isInCCLiframe';
import { DD_RUM } from '../datadog';

const renderHeight = () => {
  if (!isInCCLiframe) {
    return `height: 100vh`;
  }
};

const StyledMainWindow = styled.div`
  display: flex;
  ${renderHeight}
`;

function App() {
  useEffect(() => {
    DD_RUM();
  }, []);

  return (
    <ApolloProvider client={getApolloClient(ORGANISATION_SERVICE_ENDPOINT)}>
      <ThemeProvider>
        <React.Fragment>
          <GlobalStyle />
          <StyledMainWindow>
            <AppRoutes />
          </StyledMainWindow>
        </React.Fragment>
      </ThemeProvider>
    </ApolloProvider>
  );
}

export default App;
